import React from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./index.module.scss"

const KioskLanguages = () => {
  const history = useHistory()

  const i18n = useTranslation()[1]

  const handleClick = (lang) => {
    localStorage.setItem("defaultLanguage", lang)

    i18n.changeLanguage(lang)

    history.push("/kiosk-delivery-types")
  }

  return (
    <div className={classes["container"]}>
      <div className={classes["lang"]}>
        <img
          className={classes["flag"]}
          src="/assets/images/Flag_of_Iran.png"
          onClick={() => handleClick("fa")}
          alt="فارسی"
        />

        <h3 className={classes["title"]}>
          فارسی
        </h3>
      </div>

      <div className={classes["lang"]}>
        <img
          className={clsx(classes["flag"], classes["middle"])}
          src="/assets/images/Flag_of_United_Kingdom.png"
          onClick={() => handleClick("en")}
          alt="english"
        />

        <h3 className={classes["title"]}>
          English
        </h3>
      </div>

      <div>
        <img
          className={classes["flag"]}
          src="/assets/images/Flag_of_arab.png"
          onClick={() => handleClick("ar")}
          alt="العربية"
        />

        <h3 className={classes["title"]}>
          العربية
        </h3>
      </div>
    </div>
  )
}

export default KioskLanguages
